import api from './api';

const deliveriesService = {
  // Criar entrega
  create: (projectId, data) => {
    return api.post(`/projects/${projectId}/delivery`, data);
  },

  // Obter entrega do projeto
  getByProject: (projectId) => {
    return api.get(`/projects/${projectId}/delivery`);
  },

  // Atualizar entrega
  update: (projectId, data) => {
    return api.put(`/projects/${projectId}/delivery`, data);
  },

  // Atualizar item do checklist
  updateChecklistItem: (itemId, data) => {
    return api.put(`/deliveries/checklist/${itemId}`, data);
  },

  // Listar todas as entregas
  getAll: (params = {}) => {
    return api.get('/deliveries', { params });
  }
};

export default deliveriesService;